import { render, staticRenderFns } from "./geo_multi.vue?vue&type=template&id=4132cffa"
import script from "./geo_multi.vue?vue&type=script&lang=ts"
export * from "./geo_multi.vue?vue&type=script&lang=ts"
import style0 from "./geostyle.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports